import React, { useContext, useEffect, useState } from "react";
import magnifier from "../../Assets/my-fronds/magnifier.svg";
import notification from "../../Assets/my-fronds/notification.svg";
import closeNotificationsIcon from "../../Assets/my-fronds/cross-square.svg";
import arrowDown from "../../Assets/my-fronds/down.svg";
import userIcon from "../../Assets/dropdown/navbar/user.svg";
import exitIcon from "../../Assets/dropdown/navbar/exit.svg";
import dotsIcon from "../../Assets/notifications/dots-vertical.svg";
import commentIcon from "../../Assets/notifications/comment-icon.svg";
import likeIcon from "../../Assets/notifications/like-icon.svg";
import acceptIcon from "../../Assets/notifications/accept.svg";
import rejectIcon from "../../Assets/notifications/reject.png";
import leftIcon from "../../Assets/notifications/left4.png";
import inviteIcon from "../../Assets/notifications/invite-icon.svg";
import taskIcon from "../../Assets/notifications/task-icon.svg";
import {
  Navbar,
  NavbarBrand,
  NavbarContent,
  NavbarItem,
  Image,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  DropdownTrigger,
} from "@nextui-org/react";
import Logo from "../../Assets/Images/logo.png";
import { Link, useNavigate } from "react-router-dom";
import { useClerk, useUser } from "@clerk/clerk-react";
import { AuthContext } from "Context/AuthContext";
import useSize from "hooks/useSize";
import { SidebarContext } from "Context/SidebarContext";
import axios from "axios";
import { toast } from "react-toastify";
import EchoClient from "Echo/echo";
import AppSearch from "components/GlobalSearch/AppSearch";


const ProfileNavbar = ({ userEmail, userFullName, userImg }) => {
  // Clerk hooks
  const { user, isLoaded } = useUser();
  const { session, signOut } = useClerk();
  
  // Token and context
  const authToken = localStorage.getItem("token");
  const { setToken } = useContext(AuthContext);
  const navigate = useNavigate();
  

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [userId, setUserId] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [confirmation, setConfirmation] = useState("");
  const [theme, setTheme] = useState("light");
  const [notificationsItems, setNotificationsItems] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const [isVibrating, setIsVibrating] = useState(false);
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [targetId, setTargetId] = useState(null);
  const [itemKey, setItemKey] = useState(null);
  
  const { width } = useSize();
  const { isOpen } = useContext(SidebarContext);
  const [isScrolled, setIsScrolled] = useState(false);

 
  
  

  const calculateUnreadCount = (notifications) => {
    const unread = notifications?.filter((item) => !item.is_read).length || 0;
    setUnreadCount(unread);
  };
  
  //  getUserData effect
  useEffect(() => {
    if (!authToken || !user) return;
    
    const fetchUserData = async () => {
      try {
        const res = await axios.get("/user", {
          headers: { Authorization: `Bearer ${authToken}` },
        });
        setUserId(res.data?.id);
      } catch (error) {
        console.error("Failed to fetch user data:", error);
      }
    };
    
    fetchUserData();
  }, [authToken, user]);
  
  //  notifications fetch effect
  useEffect(() => {
    if (!userId || !authToken) return;
    
    let isMounted = true;
    
    const fetchNotifications = async () => {
      try {
        const { data } = await axios.get(
          `/notifications`,
          {
            headers: { Authorization: `Bearer ${authToken}` },
            timeout: 10000,
          }
        );
        
        if (isMounted) {
          setNotificationsItems(data?.notifications || []);
          calculateUnreadCount(data?.notifications || []);
        }
      } catch (error) {
        console.error("Notifications fetch failed:", error);
        if (isMounted) {
          setNotificationsItems([]);
        }
      }
    };
    
    fetchNotifications();
    
    return () => {
      isMounted = false;
    };
  }, [userId, authToken]);
  
  //  Echo connection effect
  useEffect(() => {
    if (!userId || !EchoClient) return;
    
    const channel = EchoClient.channel(`notifications.${userId}`);
    const handler = (event) => {
      setNotificationsItems(event?.notifications || []);
      calculateUnreadCount(event?.notifications || []);
      setIsVibrating(true);
      setTimeout(() => setIsVibrating(false), 1000);
    };
    
    channel.listen("NotificationSent", handler);
    
    return () => {
      channel.stopListening("NotificationSent", handler);
      EchoClient.leaveChannel(`notifications.${userId}`);
    };
  }, [userId]);
  
  // Notification CRUD functions
  const readNotification = async (id) => {
    try {
      await axios.post(
        `/notifications/${id}/read`,
        {},
        {
          headers: { Authorization: `Bearer ${authToken}` },
        }
      );
      // Refresh notifications after marking as read
      const { data } = await axios.get(
        `/notifications`,
        {
          headers: { Authorization: `Bearer ${authToken}` },
        }
      );
      setNotificationsItems(data?.notifications || []);
      calculateUnreadCount(data?.notifications || []);
    } catch (error) {
      console.error("Failed to mark as read:", error);
    }
  };
  
  const deleteNotification = async (id) => {
    try {
      await axios.delete(
        `/notifications/${id}/delete`,
        {
          headers: { Authorization: `Bearer ${authToken}` },
        }
      );
      // Refresh notifications after deletion
      const { data } = await axios.get(
        `/notifications`,
        {
          headers: { Authorization: `Bearer ${authToken}` },
        }
      );
      setNotificationsItems(data?.notifications || []);
      calculateUnreadCount(data?.notifications || []);
    } catch (error) {
      console.error("Failed to delete notification:", error);
    }
  };
  
  // Effect for handling notification actions
  useEffect(() => {
    if (itemKey === "Remove Notification") {
      deleteNotification(targetId);
      setItemKey(null);
    } else if (itemKey === "Mark as read") {
      readNotification(targetId);
      setItemKey(null);
    }
  }, [itemKey]);
  
  const openModal = (key, id) => {
    setItemKey(key);
    setTargetId(id);
  };
  
  // Storage event handler
  useEffect(() => {
    const handleStorageChange = (event) => {
      if (event.key === "token" && !event.newValue) {
        setToken(null);
        navigate("/login");
        localStorage.removeItem("token");
        sessionStorage.clear();
      }
    };
    
    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);
  
  // Logout function
  const logout = async () => {
    try {
      if (session) {
        await session.end();
      }
      setToken(null);
      localStorage.removeItem("token");
      sessionStorage.clear();
      navigate("/login");
    } catch (error) {
      console.error("Logout failed:", error);
      setToken(null);
      localStorage.removeItem("token");
      navigate("/login");
    }
  };
  
  // Scroll handler
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setIsScrolled(!(isOpen && width < 768));
      } else {
        setIsScrolled(false);
      }
    };
    
    window.addEventListener("scroll", handleScroll);
    handleScroll();
    
    return () => window.removeEventListener("scroll", handleScroll);
  }, [isOpen, width]);
  
  // Resize handler for notifications
  useEffect(() => {
    const timeout = setTimeout(() => {
      const scrollOutter = document.querySelector(".scroll-outter");
      const scrollInner = document.querySelector(".scroll-inner");
      
      if (scrollOutter && scrollInner) {
        const scrollOutterWidth = scrollOutter.offsetWidth;
        if (width >= 1024) {
          scrollInner.style.width = `calc(${scrollOutterWidth + (notificationsItems?.length > 4 ? 20 : 10)}px)`;
        } else {
          scrollInner.style.width = `calc(${scrollOutterWidth + 8}px)`;
        }
      }
    }, 500);
    
    return () => clearTimeout(timeout);
  }, [isDropdownOpen, width, notificationsItems?.length]);

     // Don't render until Clerk is ready
  if (!isLoaded) {
    return null;
  }
  
  // Time ago function
  const timeAgo = (dateString) => {
    const now = new Date();
    const date = new Date(dateString);
    const diffInSeconds = Math.floor((now - date) / 1000);
    
    const timeUnits = [
      { name: "year", seconds: 31536000 },
      { name: "month", seconds: 2592000 },
      { name: "day", seconds: 86400 },
      { name: "hour", seconds: 3600 },
      { name: "minute", seconds: 60 },
      { name: "second", seconds: 1 },
    ];
    
    for (const unit of timeUnits) {
      const interval = Math.floor(diffInSeconds / unit.seconds);
      if (interval >= 1) {
        return `${interval} ${unit.name}${interval > 1 ? "s" : ""} ago`;
      }
    }
    return "just now";
  };
  
  // Open notification handler
  const openNotification = (id, type, link) => {
    readNotification(id);
    if (type === "task") {
      navigate(`/frond/tasklist/all/${link}`);
    } else if (type === "like" || type === "comment") {
      navigate(`/community`);
    } else if (type === "invite") {
      navigate(`/invitations`);
    } else if (type === "invite_response_accept" || type === "invite_response_reject" || type === "project_member_left") {
      navigate(`/frond/${link}`);
    }
  };
  
  // Delete account handler
  const handleDeleteAccount = async () => {
    if (confirmation !== "DELETE") {
      toast.error('Please type "DELETE" to confirm');
      return;
    }
    
    setIsDeleting(true);
    
    try {
      if (user && typeof user.delete === 'function') {
        await user.delete();
      }
      
      await axios.delete(
        "/user/account",
        {
          headers: { Authorization: `Bearer ${authToken}` },
          data: { confirmation: "DELETE" },
        }
      );
      
      toast.success("Account deleted successfully");
      await signOut();
      localStorage.removeItem("token");
      sessionStorage.clear();
      setToken(null);
      navigate("/signup");
    } catch (error) {
      console.error("Delete account failed:", error);
      toast.error("Failed to delete account. Please try again.");
    } finally {
      setIsDeleting(false);
      setShowDeleteModal(false);
      setConfirmation("");
    }
  };
  return (
    <>
      <Navbar
        isBordered
        isMenuOpen={isMenuOpen}
        onMenuOpenChange={setIsMenuOpen}
        maxWidth="full"
        style={{ height: "69px", zIndex: "9999" }}
        className={`shadow-navShadow ${
          isScrolled ? "bg-[rgba(255,255,255,.9)]" : "bg-[#fff]"
        } 2xl:px-[120px] xl:px-[60px] sm:px-[30px] px-2.5 profile-nav border-none`}
      >
        <NavbarContent className="flex gap-9" justify="start w-fit">
          <NavbarBrand style={{ maxWidth: "98px", maxHeight: "28px" }}>
            <Link to={"/"}>
              <Image src={Logo} style={{ width: "98px", maxHeight: "28px" }} />
            </Link>
          </NavbarBrand>
          <NavbarItem className="hidden search-navbar sm:flex">
            <button
              onClick={() => {
                setIsSearchOpen(true);
              }}
              className="px-15px h-[39px] w-[284px] bg-[#F5F6FF] rounded-[20px] flex items-center gap-2.5"
            >
              <Image
                src={magnifier}
                alt="magnifier"
                className="min-w-[18px] min-h-[18px]"
              />
              <span className="text-[#424C9BB2] opacity-70">
                Search frond...
              </span>
            </button>
          </NavbarItem>
        </NavbarContent>

        <NavbarContent justify="end w-fit" className="flex gap-9">
          <NavbarItem className="w-[24px] h-[24px]">
            <Dropdown
              closeOnSelect={false}
              isOpen={isDropdownOpen}
              onOpenChange={(open) => setIsDropdownOpen(open)}
              classNames={{
                content:
                  "sm:min-w-[380px] sm:max-w-[380px] min-w-[300px] max-w-[300px] p-0 rounded-[20px]",
                base: "p-0",
              }}
              placement="bottom-end"
            >
              <DropdownTrigger className="relative">
                <button
                  className={`w-[24px] h-[24px] ${
                    isVibrating ? "bell-ring" : ""
                  }`}
                >
                  <Image src={notification} alt="notification" />
                  {unreadCount > 0 && (
                    <span className="absolute top-[-4px] right-[-8px] bg-red-500 z-10 text-white text-xs font-bold rounded-full w-5 h-5 flex items-center justify-center">
                      {unreadCount}
                    </span>
                  )}
                </button>
              </DropdownTrigger>

              <DropdownMenu
                classNames={{
                  base: "p-0 scroll-outter overflow-hidden rounded-[20px]",
                  list: "overflow-x-hidden overflow-y-auto max-h-[400px] rounded-[20px] gap-0 relative scroll-inner",
                }}
                aria-label="Static Actions"
              >
                <DropdownItem
                  isReadOnly
                  className="min-h-[56px] max-h-[56px] z-[99] bg-white fixed rounded-tl-[20px] rounded-tr-[20px] rounded-br-none rounded-bl-none top-0 left-0 right-0 p-0"
                >
                  <div className="flex items-center justify-between px-5">
                    <div className="flex items-center gap-2">
                      <Image
                        src={notification}
                        className="w-[24px] h-[24px]"
                        alt="notification"
                      />
                      <h4 className="text-lg font-bold text-blueTimeline">
                        Notifications
                      </h4>
                    </div>
                    <button onClick={() => setIsDropdownOpen(!isDropdownOpen)}>
                      <Image
                        src={closeNotificationsIcon}
                        alt="Close Notifications"
                        className="w-[24px] h-[24px]"
                      />
                    </button>
                  </div>
                </DropdownItem>
                {notificationsItems?.length > 0 ? (
                  notificationsItems.map((item, idx) => (
                    <DropdownItem
                      onClick={() => {
                        setIsDropdownOpen(false);
                        openNotification(item?.id, item?.type, item?.link);
                      }}
                      key={item?.id}
                      textValue={`${item?.sender?.name} ${item?.type} ${item?.title}`}
                      className={`${
                        idx === 0 ? "pt-[56px] pb-0 px-0" : "p-0"
                      } notification-item`}
                    >
                      <div
                        className={`flex justify-between gap-2.5 px-5 py-2.5 ${
                          item?.is_read ? "bg-white" : "bg-lightWhite"
                        }`}
                      >
                        <div className="flex items-start gap-2">
                          <div className="relative">
                            <Image
                              src={item?.sender?.img_url}
                              alt={item?.sender?.name}
                              className="min-w-[50px] min-h-[50px] max-w-[50px] max-h-[50px] rounded-full"
                            />
                            <div className="absolute bottom-0 right-0 min-w-5 min-h-5">
                              {item?.type === "task" && (
                                <Image
                                  src={taskIcon}
                                  className="w-5 h-5"
                                  alt="Task"
                                />
                              )}
                              {item?.type === "invite" && (
                                <Image
                                  src={inviteIcon}
                                  className="w-5 h-5"
                                  alt="Task"
                                />
                              )}
                              {item?.type === "comment" && (
                                <Image
                                  src={commentIcon}
                                  className="w-5 h-5"
                                  alt="Task"
                                />
                              )}
                              {item?.type === "like" && (
                                <Image
                                  src={likeIcon}
                                  className="w-5 h-5"
                                  alt="Task"
                                />
                              )}
                              {item?.type === "invite_response_accept" && (
                                <Image
                                  src={acceptIcon}
                                  className="w-5 h-5"
                                  alt="Task"
                                />
                              )}
                              {item?.type === "invite_response_reject" && (
                                <Image
                                  src={rejectIcon}
                                  className="w-5 h-5"
                                  alt="Task"
                                />
                              )}
                              {item?.type === "project_member_left" && (
                                <Image
                                  src={leftIcon}
                                  className="w-5 h-5"
                                  alt="Task"
                                />
                              )}
                            </div>
                          </div>
                          <div className="flex flex-col">
                            <p className="mb-1.5 text-cardGrayColor leading-[22px] font-normal text-sm break-words">
                              <span className="font-bold text-textColor">
                                {item?.sender?.name}{" "}
                              </span>
                              {item?.type === "task" &&
                                "assigned you a task in"}
                              {item?.type === "invite" && "Invited you to"}
                              {item?.type === "comment" && "commented on your"}
                              {item?.type === "like" && "liked your"}
                              {item?.type === "invite_response_accept" && "accepted your invitation to"}
                              {item?.type === "invite_response_reject" && "rejected your invitation to"}
                              {item?.type === "project_member_left" && "has left your project"}
                              <span className="font-bold text-textColor">
                                {" "}
                                {item?.title}
                              </span>
                            </p>
                            <p className="text-cardGrayColor text-xs leading-[13.8px]">
                              {timeAgo(item?.updated_at)}
                            </p>
                          </div>
                        </div>
                        <Dropdown
                          classNames={{
                            content:
                              "min-w-[164px] max-w-[164px] py-0 px-[5px] rounded-[10px]",
                          }}
                          placement="left-start"
                        >
                          <DropdownTrigger>
                            <button
                              className="w-[24px] h-[24px]"
                              onClick={(e) => {
                                e.stopPropagation();
                              }}
                            >
                              <img
                                src={dotsIcon}
                                alt="Dots"
                                className="min-w-[24px] min-h-[24px]"
                              />
                            </button>
                          </DropdownTrigger>
                          <DropdownMenu
                            aria-label="Notifications Actions"
                            onAction={(key) => openModal(key, item?.id)}
                          >
                            <DropdownItem
                              textValue="Mark as read"
                              key="Mark as read"
                              className="text-textColor text-sm font-normal py-[2px] px-[5px] relative after:absolute after:left-0 after:right-0 after:bottom-[-2.5px] after:h-px after:bg-grayBorder mb-[5px] selected-action"
                            >
                              Mark as read
                            </DropdownItem>
                            <DropdownItem
                              key="Remove Notification"
                              textValue="Remove Notification"
                              className="text-[#EB6270] text-sm font-normal py-[2px] px-[2px] selected-action"
                              color="danger"
                            >
                              Remove Notification
                            </DropdownItem>
                          </DropdownMenu>
                        </Dropdown>
                      </div>
                    </DropdownItem>
                  ))
                ) : (
                  <DropdownItem
                    isReadOnly
                    className="pt-[56px] pb-0 px-5 pointer-events-none"
                  >
                    <span className="text-textColor font-medium text-lg flex justify-center items-center pb-2.5">
                      There are no notifications
                    </span>
                  </DropdownItem>
                )}
              </DropdownMenu>
            </Dropdown>
          </NavbarItem>
          <NavbarItem>
            <Dropdown
              classNames={{
                content:
                  "min-[380px]:min-w-[341px] min-[380px]:max-w-[341px] min-w-[300px] max-w-[300px] p-5 rounded-[20px]",
              }}
              placement="bottom-end"
              closeOnSelect={true}
            >
              <DropdownTrigger>
                <button className="flex items-center gap-1">
                  <Image
                    src={userImg ? userImg : user?.imageUrl}
                    alt="Profile Pic"
                    className="w-[34px] h-[34px] rounded-full"
                  />
                  <Image src={arrowDown} alt="Arrow" />
                </button>
              </DropdownTrigger>
              <DropdownMenu aria-label="User Account" variant="light">
                <DropdownItem
                  isReadOnly
                  key="user Info"
                  textValue={`${userFullName ? userFullName : user?.fullName} - ${userEmail ? userEmail : user?.primaryEmailAddress?.emailAddress}`}
                  className="relative cursor-auto p-0 after:absolute after:left-0 after:right-0 after:bottom-[-20px] after:h-px after:bg-grayBorder mb-[35px]"
                >
                  <div className="flex items-center gap-4">
                    <Image
                      src={userImg ? userImg : user?.imageUrl}
                      alt="Profile Pic"
                      className="min-w-[50px] min-h-[50px] max-w-[50px] max-h-[50px] rounded-full"
                    />
                    <div className="user-data">
                      <h4 className="text-base font-bold text-textColor mb-0.5">
                        {userFullName ? userFullName : user?.fullName}
                      </h4>
                      <p className="text-base font-normal text-cardGrayColor break-before-all">
                        {userEmail
                          ? userEmail
                          : user?.primaryEmailAddress?.emailAddress}
                      </p>
                    </div>
                  </div>
                </DropdownItem>
                <DropdownItem
                  key="Profile"
                  textValue="My Profile"
                  className="relative p-0 after:absolute after:left-0 after:right-0 after:bottom-[-20px] after:h-px after:bg-grayBorder mb-[30px]"
                >
                  <Link
                    to={"/profile"}
                    className="flex items-center gap-2 transition-all duration-300 bg-white hover:bg-[#F5F6FF] rounded-[10px] py-2 px-2.5"
                  >
                    <Image src={userIcon} alt="User" />
                    <p className="text-base font-normal text-textColor">
                      My Profile
                    </p>
                  </Link>
                </DropdownItem>
                {/* <DropdownItem
                  isReadOnly
                  key="Theme"
                  className={`relative p-0 after:absolute after:left-0 after:right-0 after:bottom-[-20px] after:h-px after:bg-grayBorder mb-[30px]`}
                >
                  <h6 className="mb-2 text-sm font-bold cursor-auto text-cardGrayColor">
                    Theme
                  </h6>

                  <div
                    className={`theme-box relative after:absolute after:bg-darkBlue after:w-1/2 ${
                      theme === "light" ? "after:left-0" : "after:left-[50%]"
                    } after:duration-300 after:transition-all after:top-0 after:bottom-0 after:rounded-[65px] after:z-10 flex items-center rounded-[65px] bg-[#F5F6FF]`}
                  >
                    <button
                      onClick={() => {
                        setTheme("light");
                      }}
                      className="relative z-20 w-1/2 py-1"
                    >
                      <div className="relative z-20 flex items-center justify-center gap-2 py-1 light">
                        <div className="relative w-[24px] h-[24px]">
                          <img
                            src={sunIcon}
                            alt="Sun"
                            className={`absolute inset-0 transition-all duration-200 ${
                              theme === "light" ? "opacity-100" : "opacity-0"
                            }`}
                          />
                          <img
                            src={sunIcon2}
                            className={`absolute inset-0 transition-all duration-200 ${
                              theme === "light" ? "opacity-0" : "opacity-100"
                            }`}
                            alt="Sun"
                          />
                        </div>
                        <span
                          className={`text-base font-normal transition-all duration-300 ${
                            theme === "light" ? "text-white" : "text-darkBlue"
                          }`}
                        >
                          Light
                        </span>
                      </div>
                    </button>
                    <button
                      onClick={() => {
                        setTheme("dark");
                      }}
                      className="relative z-20 w-1/2 py-1"
                    >
                      <div className="relative z-20 flex items-center justify-center gap-2 py-1 dark">
                        <div className="relative w-[24px] h-[24px]">
                          <img
                            src={moonIcon}
                            alt="Moon"
                            className={`absolute inset-0 transition-all duration-200 ${
                              theme === "dark" ? "opacity-0" : "opacity-1000"
                            }`}
                          />
                          <img
                            src={moonIcon2}
                            className={`absolute inset-0 transition-all duration-200 ${
                              theme === "dark" ? "opacity-100" : "opacity-0"
                            }`}
                            alt="Moon"
                          />
                        </div>
                        <span
                          className={`text-base font-normal transition-all duration-300 ${
                            theme === "dark" ? "text-white" : "text-darkBlue"
                          }`}
                        >
                          Dark
                        </span>
                      </div>
                    </button>
                  </div>
                </DropdownItem> */}
                <DropdownItem isReadOnly key="Sign out" textValue="Log Out" className="p-0">
                  <button
                    onClick={() => {
                      logout();
                    }}
                    className="flex items-center gap-3 py-2 px-2.5 w-full transition-all duration-300 bg-white hover:bg-[#F5F6FF] rounded-[10px] "
                  >
                    <Image src={exitIcon} alt="Exit" />
                    <h6 className="text-base font-normal text-textColor">
                      Log Out
                    </h6>
                  </button>
                </DropdownItem>
                <DropdownItem isReadOnly key="Delete Account" textValue="Delete Account" className="p-0">
                  <div style={{ padding: "10px" }}>
                    <input
                      type="text"
                      placeholder='Type "DELETE" to confirm'
                      value={confirmation}
                      onChange={(e) => setConfirmation(e.target.value)}
                      style={{
                        width: "100%",
                        padding: "8px",
                        marginBottom: "8px",
                        borderRadius: "5px",
                        border: "1px solid #ccc",
                      }}
                    />
                    <button
                      onClick={handleDeleteAccount}
                      disabled={isDeleting || confirmation !== "DELETE"}
                      style={{
                        width: "100%",
                        backgroundColor: "#dc2626",
                        padding: "12px 16px",
                        borderRadius: "5px",
                        border: "none",
                        color: "#ffffff",
                        fontWeight: "bold",
                        cursor: isDeleting ? "not-allowed" : "pointer",
                        opacity: isDeleting || confirmation !== "DELETE" ? 0.5 : 1,
                        transition: "all 0.2s ease-in-out",
                      }}
                    >
                      {isDeleting ? "Deleting..." : "Delete Account"}
                    </button>
                  </div>
                </DropdownItem>

              </DropdownMenu>
            </Dropdown>
          </NavbarItem>
        </NavbarContent>
      </Navbar>
      {/* {isSearchOpen && (
        <GlobalSearch
          isOpen={isSearchOpen}
          onClose={() => {
            setIsSearchOpen(false);
          }}
        />
      )} */}
      {isSearchOpen && (
        <AppSearch
          isOpen={isSearchOpen}
          onClose={() => {
            setIsSearchOpen(false);
          }}
        />
      )}
    </>
  );
};

export default ProfileNavbar;
